export default {
  contextTypes: {
    sharedBindings() {},
  },

  getSharedBinding(name) {
    return this.context.sharedBindings[name];
  },
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/shared_bindings_mixin.js